var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEResync({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M16 4        C10.8867 4 6.6172 7.1602 4.875 11.625        L6.7188 12.375        C8.1758 8.6406 11.7109 6 16 6        C19.2422 6 22.1328 7.5898 23.9375 10        L20 10 L20 12 L27 12 L27 5        L25 5 L25 8.0938        C22.8086 5.582 19.5703 4 16 4 Z        M25.2813 19.625        C23.8242 23.3594 20.2891 26 16 26        C12.7227 26 9.8438 24.3867 8.0313 22        L12 22 L12 20 L5 20 L5 27        L7 27 L7 23.9063        C9.1875 26.3867 12.3945 28 16 28        C21.1133 28 25.3828 24.8398 27.125 20.375 Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 21,
    textAnchor: "middle",
    fontSize: 14,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "bold",
    fill: "#000000"
  }, "\n    E\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEResync);
export default __webpack_public_path__ + "static/media/e_resync.56bca7e1e080abc201cc9158906db5d9.svg";
export { ForwardRef as ReactComponent };